import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { PersonPartner } from 'src/modules/serasa/serasa.experian.person.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'

export type ParticipacaoSocietariaProps = {
    participacoes?: PersonPartner[]
}

const participacaoSocietariaColumns = static_build_participacao_societaria_columns()

export default function ParticipacaoSocietaria({ participacoes }: ParticipacaoSocietariaProps) {
    if (participacoes && participacoes.length) {
        return (
            <>
                <Divider textAlign="center">Participação Societária</Divider>

                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <Grid item xs={12}>
                        <DataGrid
                            rows={participacoes}
                            columns={participacaoSocietariaColumns}
                            getRowId={static_getRowId}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
    return <></>
}

function static_getRowId(row: PersonPartner) {
    return row.businessDocument
}

function static_build_participacao_societaria_columns(): GridColDef[] {
    return [
        {
            field: 'companyName',
            headerName: 'Empresa',
            width: 300
        },
        {
            field: 'businessDocument',
            headerName: 'CNPJ',
            width: 100
        },
        {
            field: 'participationPercentage',
            headerName: 'Participação',
            width: 50
        },
        {
            field: 'participationInitialDate',
            headerName: 'Desde',
            valueGetter(params) {
                return formatDateNoTz(params.row.participationInitialDate)
            },
            width: 100
        },
        {
            field: 'companyState',
            headerName: 'UF',
            width: 50
        },
        {
            field: 'companyStatus',
            headerName: 'Situação',
            width: 50
        },
        {
            field: 'companyStatusDate',
            headerName: 'Data Situação',
            valueGetter(params) {
                return formatDateNoTz(params.row.companyStatusDate)
            },
            width: 100
        }
    ]
}
